import { render, staticRenderFns } from "./MerchantPanel.vue?vue&type=template&id=5f73ae5b&scoped=true"
import script from "./MerchantPanel.vue?vue&type=script&lang=js"
export * from "./MerchantPanel.vue?vue&type=script&lang=js"
import style0 from "./MerchantPanel.vue?vue&type=style&index=0&id=5f73ae5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73ae5b",
  null
  
)

export default component.exports